var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Footer-Open-Large-Desktop->=1200","transform":"translate(-1291.000000, -333.000000)","fill":"#6F7881"},React.createElement("path",{"d":"M1292.87353,341.677461 L1291,341.677461 L1291,339.061171 L1292.87353,339.061171 L1292.87353,336.894181 C1292.87353,334.606678 1294.00882,333 1296.40103,333 L1298.09,333.002 L1298.09,335.755805 L1296.96867,335.755805 C1296.03767,335.755805 1295.68361,336.544392 1295.68361,337.275723 L1295.68361,339.062171 L1298.08911,339.062171 L1297.55692,341.677461 L1295.68361,341.677461 L1295.68361,349.07678 L1292.87353,349.07678 L1292.87353,341.677461 Z","id":"facebook"}))));
}

Facebook.displayName = "Facebook";

Facebook.defaultProps = {"width":"8px","height":"17px","viewBox":"0 0 8 17","version":"1.1"};

module.exports = Facebook;

Facebook.default = Facebook;
